import { Component } from "@angular/core";
import { Router } from "@angular/router";

@Component({
  selector: "app-login-page",
  templateUrl: "./login-page.component.html",
  styleUrls: ["./login-page.component.scss"],
})
export class LoginPageComponent {
  public title = "common.welcomeBack";

  constructor(private router: Router) {
    const navigation = this.router.getCurrentNavigation();
    const state = navigation?.extras?.state;

    if (state) {
      this.title = state["title"];
    }
  }

  /**
   * Navigates to home after successful login
   * @param event Indicates whether login succeeded
   */
  public loginFormSubmit(event: boolean): void {
    if (event) {
      this.router.navigate(["/home"]);
    }
  }
}
